import { render, staticRenderFns } from "./omDetail.vue?vue&type=template&id=18f35ecf&scoped=true"
import script from "./omDetail.vue?vue&type=script&lang=js"
export * from "./omDetail.vue?vue&type=script&lang=js"
import style0 from "./omDetail.vue?vue&type=style&index=0&id=18f35ecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f35ecf",
  null
  
)

export default component.exports